import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'
import Index from '../views/Index.vue'
import Contact from '../views/Contact.vue'
import Log from '../views/Log.vue'
import Link from '../views/Link.vue'
import ArticleList from '../views/ArticleList.vue'
import Article from '../views/Article.vue'
import Search from '../views/Search.vue'
import Chara from '../views/Chara.vue'
import CharaList from '../views/CharaList.vue'
import Profile from '../views/Profile.vue'
import Story from '../views/Story.vue'
import Closet from '../views/Closet.vue'
import Gallery from '../views/Gallery.vue'
import GalleryList from '../views/GalleryList.vue'
import ClosetList from '../views/ClosetList.vue'
import UnderConstruction from '../views/UnderConstruction.vue'
import Login from '../views/Login.vue'
import Homepage from '../views/Homepage.vue'
import Pic from '../views/Pic.vue'
import Form from '../views/Form.vue'
import RelationList from '../views/RelationList.vue'
import Relation from '../views/Relation.vue'
import Employee from '@/views/Employee.vue'
import CharaManage from '@/views/CharaManage.vue'
import CommissionManage from '@/views/CommissionManage.vue'
import ClosetManage from '@/views/ClosetManage.vue'
import Height from '@/views/Height.vue'
import Test from '@/views/Test.vue'
import Couple from '@/views/Couple.vue'
import RelationNet from '@/views/RelationNet.vue'
import RelationGallery from '@/views/RelationGallery.vue'
import RelationProfile from '@/views/RelationProfile.vue'

const routes = [
  {
    path: '/',
    name: 'index',
    component: Index
  },
  
  {
    path: '/contact',
    name: 'contact',
    component: Contact
  },
  {
    path: '/log',
    name: 'log',
    component: Log
  },
  {
    path: '/link',
    name: 'link',
    component: Link
  },
  {
    path: '/article_list',
    name: 'article_list',
    component: ArticleList
  },
  {
    path: '/article/:title(.*)*',
    name: 'article',
    component: Article
  },
  {
    path: '/search',
    name: 'search',
    component: Search
  },
  {
    path: '/chara/:name(.*)*',
    name: 'chara',
    component: Chara,
    redirect: { name: 'profile' },
    children: [
      {
        path: 'profile',
        name: 'profile',
        component: Profile
      },
      {
        path: 'story',
        name: 'story',
        component: Story
      },
      {
        path: 'closet',
        name: 'closet',
        component: Closet
      },
      {
        path: 'gallery',
        name: 'gallery',
        component: Gallery
      }
    ]
  },
 
  {
    path: '/chara_list/:world(.*)*',
    name: 'chara_list',
    component: CharaList
  },
  {
    path: '/gallery_list',
    name: 'gallery_list',
    component: GalleryList
  },
  {
    path: '/closet_list/:world(.*)*',
    name: 'closet_list',
    component: ClosetList
  },
  {
    path: '/underconstruction',
    name: 'underconstruction',
    component: UnderConstruction
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/homepage',
    name: 'homepage',
    component: Homepage
  },
  {
    path: '/pic',
    name: 'pic',
    component: Pic
  },
  {
    path: '/form',
    name: 'form',
    component: Form
  },
    {
    path: '/relation_list',
    name: 'RelationList',
    component: RelationList
  },
    {
    path: '/relation/:title(.*)*',
    name: 'Relation',
    component: Relation,
    redirect: { name: 'relation_profile' },
    children: [
      {
        path: 'profile',
        name: 'relation_profile',
        component: RelationProfile
      },
      {
        path: 'gallery',
        name: 'relation_gallery',
        component: RelationGallery
      }
    ]
  },
   {
    path: '/homepage',
    name: 'homepage',
    redirect:'/homepage/employee',
    component: Homepage,
    children: [
      {
        path: 'employee',
        name: 'employee',
        component: Employee
      },
      {
        path: 'charaManage',
        name: 'charaManage',
        component: CharaManage
      },
      {
        path: 'commissionManage',
        name: 'commissionManage',
        component: CommissionManage
      },
      {
        path: 'closetManage',
        name: 'closetManage',
        component: ClosetManage
      }
    ]
  },
  {
    path: '/height',
    name: 'Height',
    component: Height
  },
  {
    path: '/test',
    name: 'Test',
    component: Test
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
